import React from "react";

import { convertHMToSecs } from "utils";

import Tooltip from "App/common/ui/Tooltip";
import { TOOLTIPS, CONTENT } from "consts";
import { ReactComponent as InformationIcon } from "assets/images/app_svg/information.svg";

function BackupPlanAdvanced(props) {
  const hours = [];
  const minutes = [];

  if (props.planSettings.cutOffTime) {
    for (let i = 0; i <= 23; i++) {
      hours.push(
        <option key={i} value={i}>
          {i > 9 ? "" + i : "0" + i}
        </option>
      );
    }
    for (let i = 0; i <= 55; i = i + 5) {
      minutes.push(
        <option key={i} value={i}>
          {i > 9 ? "" + i : "0" + i}
        </option>
      );
    }
  }

  function toggleCutOffTime(val, type) {
    let tempPlan = { ...props.planSettings };
    let hours = Math.trunc(tempPlan.cutOffTime.value / 3600);
    let minutes = Math.trunc((tempPlan.cutOffTime.value % 3600) / 60);
    let seconds = tempPlan.cutOffTime.value % 60;
    val = parseInt(val) || 0;

    if (type === "hr") {
      hours = Math.min(23, Math.max(0, val));
    } else if (type === "mn") {
      minutes = Math.min(59, Math.max(0, val));
    } else if (type === "ss") {
      seconds = Math.min(59, Math.max(0, val));
    }

    tempPlan.cutOffTime.value = hours * 3600 + minutes * 60 + seconds;
    props.setPlanSettings(tempPlan);
  }

  const handleInput = (e, limit) => {
    let val = e.target.value.replace(/\D/g, "");
    if (val.length > 2) {
      val = val.slice(-2);
    }
    if (val === "") {
      val = "00";
    }
    let num = Number(val);
    if (num > limit) {
      num = num % 10; // take last digit only
    }
    const formatted = String(num).padStart(2, "0");
    e.target.value = formatted;
  };

  return (
    <div className="schedule_backup_advance">
      <div className="transparent_layer"></div>
      <div className="input_checkboxw cut_off_row just_flex  ">
        <div className="check">
          {props.planSettings.cutOffTime.isEnabled && (
            <input
              type="checkbox"
              className="input_checkbox"
              id="schedule_backup_122"
              checked
              onClick={() =>
                props.setPlanSettings({
                  ...props.planSettings,
                  cutOffTime: {
                    ...props.planSettings.cutOffTime,
                    isEnabled: !props.planSettings.cutOffTime.isEnabled
                  }
                })
              }
            />
          )}
          {!props.planSettings.cutOffTime.isEnabled && (
            <input
              type="checkbox"
              className="input_checkbox"
              id="schedule_backup_122"
              onClick={() =>
                props.setPlanSettings({
                  ...props.planSettings,
                  cutOffTime: {
                    ...props.planSettings.cutOffTime,
                    isEnabled: !props.planSettings.cutOffTime.isEnabled
                  }
                })
              }
            />
          )}
          <label htmlFor="schedule_backup_122"></label>
        </div>
        <div className="cow_box ">
          <div className="cutt-off_wrap flex_align">
            <p
              className="checkbox_p"
              onClick={() =>
                props.setPlanSettings({
                  ...props.planSettings,
                  cutOffTime: {
                    ...props.planSettings.cutOffTime,
                    isEnabled: !props.planSettings.cutOffTime.isEnabled
                  }
                })
              }
            >
              Cut-off Time:{" "}
            </p>
            <div className="cow_box ">
              <div
                className={`cutt-off_wrap flex_align ${
                  !props.planSettings.cutOffTime.isEnabled
                    ? "transparent_layer_wrap"
                    : ""
                }`}
              >
                <div class="transparent_layer" />
                <div className="hours_mins_wrap hours_min_seconds_wrap flex_align">
                  <div className="id-hr-set">
                    <input
                      type="number"
                      min={0}
                      max={23}
                      placeholder="HH"
                      onChange={e => toggleCutOffTime(e.target.value, "hr")}
                      onInput={e => handleInput(e, 23)}
                      value={Math.trunc(
                        props.planSettings.cutOffTime.value / 3600
                      )}
                    />
                  </div>
                  <span class="id-min-set">
                    <input
                      type="number"
                      min={0}
                      max={59}
                      placeholder="MM"
                      onChange={e => toggleCutOffTime(e.target.value, "mn")}
                      onInput={e => handleInput(e, 59)}
                      value={Math.trunc(
                        (props.planSettings.cutOffTime.value % 3600) / 60
                      )}
                    />
                  </span>
                  <span class="id-sec-set">
                    <input
                      type="number"
                      min={0}
                      max={59}
                      placeholder="SS"
                      onChange={e => toggleCutOffTime(e.target.value, "ss")}
                      onInput={e => handleInput(e, 59)}
                      value={Math.trunc(
                        (props.planSettings.cutOffTime.value % 3600) % 60
                      )}
                    />
                  </span>
                  <Tooltip {...TOOLTIPS.backupSettings.schedule.cutOff}>
                    <span className="icon">
                      <InformationIcon />
                    </span>
                  </Tooltip>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Prevent sleep */}
      {/* <div className="input_checkboxw just_flex">
        <div className="check">
          {props.planSettings.scheduleInfo.advanced.preventSleep && (
            <input
              type="checkbox"
              className="input_checkbox"
              id="schedule_backup_21"
              checked
              onClick={() =>
                props.setPlanSettings({
                  ...props.planSettings,
                  scheduleInfo: {
                    ...props.planSettings.scheduleInfo,
                    advanced: {
                      ...props.planSettings.scheduleInfo.advanced,
                      preventSleep: !props.planSettings.scheduleInfo.advanced
                        .preventSleep
                    }
                  }
                })
              }
            />
          )}
          {!props.planSettings.scheduleInfo.advanced.preventSleep && (
            <input
              type="checkbox"
              className="input_checkbox"
              id="schedule_backup_21"
              onClick={() =>
                props.setPlanSettings({
                  ...props.planSettings,
                  scheduleInfo: {
                    ...props.planSettings.scheduleInfo,
                    advanced: {
                      ...props.planSettings.scheduleInfo.advanced,
                      preventSleep: !props.planSettings.scheduleInfo.advanced
                        .preventSleep
                    }
                  }
                })
              }
            />
          )}
          <label htmlFor="schedule_backup_21"></label>
        </div>
        <p
          className="checkbox_p"
          onClick={() =>
            props.setPlanSettings({
              ...props.planSettings,
              scheduleInfo: {
                ...props.planSettings.scheduleInfo,
                advanced: {
                  ...props.planSettings.scheduleInfo.advanced,
                  preventSleep: !props.planSettings.scheduleInfo.advanced
                    .preventSleep
                }
              }
            })
          }
        >
          {CONTENT.backupSettings.backupSchedule.advance.hibernate}
        </p>
      </div> */}
      {/* temporary changes */}
      {/* <div className="input_checkboxw just_flex">
        <div className="check">
          {props.planSettings.emailNotification.notifyOnDesktop && (
            <input
              type="checkbox"
              className="input_checkbox"
              id="schedule_backup_25"
              checked
              onClick={() =>
                props.setPlanSettings({
                  ...props.planSettings,
                  emailNotification: {
                    ...props.planSettings.emailNotification,
                    notifyOnDesktop: !props.planSettings.emailNotification
                      .notifyOnDesktop
                  }
                })
              }
            />
          )}
          {!props.planSettings.emailNotification.notifyOnDesktop && (
            <input
              type="checkbox"
              className="input_checkbox"
              id="schedule_backup_25"
              onClick={() =>
                props.setPlanSettings({
                  ...props.planSettings,
                  emailNotification: {
                    ...props.planSettings.emailNotification,
                    notifyOnDesktop: !props.planSettings.emailNotification
                      .notifyOnDesktop
                  }
                })
              }
            />
          )}
          <label htmlFor="schedule_backup_25"></label>
        </div>
        <p
          className="checkbox_p"
          onClick={() =>
            props.setPlanSettings({
              ...props.planSettings,
              emailNotification: {
                ...props.planSettings.emailNotification,
                notifyOnDesktop: !props.planSettings.emailNotification
                  .notifyOnDesktop
              }
            })
          }
        >
          {CONTENT.backupSettings.backupSchedule.advance.notifyOnDesktop}
        </p>
      </div> */}
      <div className="input_checkboxw just_flex">
        <div className="check">
          {props.planSettings.scheduleInfo.advanced.runMissed && (
            <input
              type="checkbox"
              className="input_checkbox"
              id="schedule_backup_22"
              checked
              onClick={() =>
                props.setPlanSettings({
                  ...props.planSettings,
                  scheduleInfo: {
                    ...props.planSettings.scheduleInfo,
                    advanced: {
                      ...props.planSettings.scheduleInfo.advanced,
                      runMissed: !props.planSettings.scheduleInfo.advanced
                        .runMissed
                    }
                  }
                })
              }
            />
          )}
          {!props.planSettings.scheduleInfo.advanced.runMissed && (
            <input
              type="checkbox"
              className="input_checkbox"
              id="schedule_backup_22"
              onClick={() =>
                props.setPlanSettings({
                  ...props.planSettings,
                  scheduleInfo: {
                    ...props.planSettings.scheduleInfo,
                    advanced: {
                      ...props.planSettings.scheduleInfo.advanced,
                      runMissed: !props.planSettings.scheduleInfo.advanced
                        .runMissed
                    }
                  }
                })
              }
            />
          )}
          <label htmlFor="schedule_backup_22"></label>
        </div>
        <p
          className="checkbox_p"
          onClick={() =>
            props.setPlanSettings({
              ...props.planSettings,
              scheduleInfo: {
                ...props.planSettings.scheduleInfo,
                advanced: {
                  ...props.planSettings.scheduleInfo.advanced,
                  runMissed: !props.planSettings.scheduleInfo.advanced.runMissed
                }
              }
            })
          }
        >
          {CONTENT.backupSettings.backupSchedule.advance.startup}
        </p>
      </div>
      <div className="input_checkboxw just_flex">
        <div className="check">
          {props.planSettings.scheduleInfo.advanced.onWakeup.checked && (
            <input
              type="checkbox"
              className="input_checkbox"
              id="schedule_backup_23"
              onClick={() =>
                props.setPlanSettings({
                  ...props.planSettings,
                  scheduleInfo: {
                    ...props.planSettings.scheduleInfo,
                    advanced: {
                      ...props.planSettings.scheduleInfo.advanced,
                      onWakeup: {
                        ...props.planSettings.scheduleInfo.advanced.onWakeup,
                        checked: !props.planSettings.scheduleInfo.advanced
                          .onWakeup.checked
                      }
                    }
                  }
                })
              }
              checked
            />
          )}
          {!props.planSettings.scheduleInfo.advanced.onWakeup.checked && (
            <input
              type="checkbox"
              className="input_checkbox"
              id="schedule_backup_23"
              onClick={() =>
                props.setPlanSettings({
                  ...props.planSettings,
                  scheduleInfo: {
                    ...props.planSettings.scheduleInfo,
                    advanced: {
                      ...props.planSettings.scheduleInfo.advanced,
                      onWakeup: {
                        ...props.planSettings.scheduleInfo.advanced.onWakeup,
                        checked: !props.planSettings.scheduleInfo.advanced
                          .onWakeup.checked
                      }
                    }
                  }
                })
              }
            />
          )}
          <label htmlFor="schedule_backup_23"></label>
        </div>
        <p
          className="checkbox_p"
          onClick={() =>
            props.setPlanSettings({
              ...props.planSettings,
              scheduleInfo: {
                ...props.planSettings.scheduleInfo,
                advanced: {
                  ...props.planSettings.scheduleInfo.advanced,
                  onWakeup: {
                    ...props.planSettings.scheduleInfo.advanced.onWakeup,
                    checked: !props.planSettings.scheduleInfo.advanced.onWakeup
                      .checked
                  }
                }
              }
            })
          }
        >
          {CONTENT.backupSettings.backupSchedule.advance.wakeup}
        </p>
      </div>
    </div>
  );
}

export default BackupPlanAdvanced;
